/* eslint-disable no-unsafe-optional-chaining */
import { Autocomplete, FormLabel, Grid, IconButton, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { FieldArray } from "formik";
import React from "react";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import Icon from "@mui/material/Icon";
import ScrollToFieldError from "pages/Coachup/Reports/components/Common/ScrollToFieldError";
import { useLocation } from "react-router-dom";

const QUESTION_TYPES = [
  {
    label: "Text",
    value: "text",
    icon: <Icon fontSize="small">text_fields</Icon>,
  },
  {
    label: "Number",
    value: "number",
    icon: <Icon fontSize="small">123</Icon>,
  },
  {
    label: "Currency",
    value: "currency",
    icon: <Icon fontSize="small">attach_money</Icon>,
  },
  {
    label: "True/False",
    value: "true/false",
    icon: <Icon fontSize="small">toggle_on</Icon>,
  },
  {
    label: "Assessment (1-10)",
    value: "assessment",
    icon: <Icon fontSize="small">assessment</Icon>,
  },
  {
    label: "Pipeline health",
    value: "pipeline health",
    icon: <Icon fontSize="small">monitor_health</Icon>,
  },
];

function Questions({ formData }) {
  const { values, errors, touched, setFieldValue } = formData;
  const location = useLocation();
  const userSpecificTemplateEdit = location.pathname.includes("user");

  return (
    <MDBox>
      <Grid container spacing={3} p={1}>
        <Grid item xs={12} sm={12}>
          <MDBox>
            <MDTypography variant="h5" fontWeight="bold">
              Questions
            </MDTypography>
            <MDTypography variant="subtitle2" sx={{ color: "#7b809a" }}>
              What questions will your template include?
            </MDTypography>
          </MDBox>
        </Grid>
        <Grid item xs={12}>
          <ScrollToFieldError scrollBehavior={{ behavior: "smooth", block: "center" }} />
          <MDBox>
            <FieldArray
              name="questions"
              render={(arrayHelpers) => (
                <MDBox>
                  {values?.questions &&
                    values?.questions.length > 0 &&
                    values.questions.map((item, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <Grid container spacing={2} mt={index !== 0 && 0.5} key={index}>
                        <Grid
                          item
                          xs={1}
                          sm={0.5}
                          sx={{
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: "center",
                            marginTop: "-30px",
                            marginBottom:
                              touched?.questions?.[index]?.question &&
                              Boolean(errors?.questions?.[index]?.question) &&
                              "18px",
                          }}
                        >
                          <MDTypography>{index + 1}</MDTypography>
                        </Grid>
                        <Grid item xs={10} sm={11}>
                          <MDInput
                            variant="standard"
                            label={
                              item.type === "pipeline health"
                                ? "How much is in your Pipeline?"
                                : "Question"
                            }
                            name={`questions.${index}.question`}
                            disabled={userSpecificTemplateEdit && item.questionId}
                            value={item.question || ""}
                            placeholder={
                              item.type === "pipeline health"
                                ? "How much is in your Pipeline?"
                                : "Question"
                            }
                            fullWidth
                            onChange={(event) => {
                              setFieldValue(`questions[${index}].question`, event.target.value);
                            }}
                            helperText={
                              touched &&
                              touched.questions &&
                              touched.questions[index] &&
                              touched.questions[index].question &&
                              errors &&
                              errors.questions &&
                              errors.questions[index] &&
                              errors.questions[index].question
                            }
                            error={
                              touched &&
                              touched.questions &&
                              touched.questions[index] &&
                              touched.questions[index].question &&
                              errors &&
                              errors.questions &&
                              errors.questions[index] &&
                              Boolean(errors.questions[index].question)
                            }
                          />
                        </Grid>
                        <Grid item xs={1} sm={0.5}>
                          {values?.questions?.length !== 1 && (
                            <IconButton sx={{ mt: 1 }} onClick={() => arrayHelpers.remove(index)}>
                              <DeleteOutline color="error" />
                            </IconButton>
                          )}
                        </Grid>
                        {item.type === "pipeline health" && (
                          <>
                            <Grid item xs={1} sm={0.5} />
                            <Grid item xs={10} sm={11}>
                              <MDInput
                                variant="standard"
                                label="What is your quota?"
                                name={`questions.${index}.childQuestion`}
                                disabled={userSpecificTemplateEdit && item.questionId}
                                value={item.childQuestion || ""}
                                placeholder="What is your quota?"
                                fullWidth
                                onChange={(event) => {
                                  setFieldValue(
                                    `questions[${index}].childQuestion`,
                                    event.target.value
                                  );
                                }}
                                helperText={
                                  touched &&
                                  touched.questions &&
                                  touched.questions[index] &&
                                  touched.questions[index].childQuestion &&
                                  errors &&
                                  errors.questions &&
                                  errors.questions[index] &&
                                  errors.questions[index].childQuestion
                                }
                                error={
                                  touched &&
                                  touched.questions &&
                                  touched.questions[index] &&
                                  touched.questions[index].childQuestion &&
                                  errors &&
                                  errors.questions &&
                                  errors.questions[index] &&
                                  Boolean(errors.questions[index].childQuestion)
                                }
                              />
                            </Grid>
                            <Grid item xs={1} sm={0.5} />
                          </>
                        )}

                        <Grid item xs={1} sm={0.5} />
                        <Grid item xs={10} sm={11}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <Stack direction="row">
                                <FormLabel sx={{ fontSize: "16px", width: "170px" }}>
                                  Answer Type
                                </FormLabel>
                                <Autocomplete
                                  fullWidth
                                  variant="standard"
                                  id="type"
                                  disableClearable
                                  disabled={userSpecificTemplateEdit && item.questionId}
                                  value={
                                    item.type
                                      ? QUESTION_TYPES.find(
                                          (question) => question.value === item.type
                                        ) || null
                                      : null
                                  }
                                  options={QUESTION_TYPES.filter((questionType) => {
                                    if (
                                      questionType.value === "assessment" &&
                                      values.questions.find(
                                        (question, idx) =>
                                          question.type === "assessment" && index !== idx
                                      )
                                    ) {
                                      return false;
                                    }
                                    return true;
                                  })}
                                  isOptionEqualToValue={(option, value) =>
                                    option?.value === value?.value
                                  }
                                  renderOption={(props, option) => (
                                    <Stack
                                      {...props}
                                      direction="row"
                                      px={2}
                                      py={1}
                                      alignItems="center"
                                      spacing={1}
                                    >
                                      {option.icon}
                                      <MDTypography sx={{ fontSize: "16px" }}>
                                        {option.label}
                                      </MDTypography>
                                    </Stack>
                                  )}
                                  onChange={(_, value) => {
                                    setFieldValue(`questions[${index}].type`, value.value || "");
                                    if (value.value === "pipeline health") {
                                      if (!item.question) {
                                        setFieldValue(
                                          `questions[${index}].question`,
                                          "How much is in your Pipeline?"
                                        );
                                      }
                                      setFieldValue(
                                        `questions[${index}].childQuestion`,
                                        "What is your quota?"
                                      );
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <MDInput
                                      {...params}
                                      placeholder="Type"
                                      variant="standard"
                                      name={`questions.${index}.type`}
                                      helperText={
                                        touched &&
                                        touched.questions &&
                                        touched.questions[index] &&
                                        touched.questions[index].type &&
                                        errors &&
                                        errors.questions &&
                                        errors.questions[index] &&
                                        errors.questions[index].type
                                      }
                                      error={
                                        touched &&
                                        touched.questions &&
                                        touched.questions[index] &&
                                        touched.questions[index].type &&
                                        errors &&
                                        errors.questions &&
                                        errors.questions[index] &&
                                        Boolean(errors.questions[index].type)
                                      }
                                    />
                                  )}
                                />
                              </Stack>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={1} sm={0.5} />
                      </Grid>
                    ))}
                  <MDBox sx={{ mt: 2 }}>
                    <MDButton
                      variant="text"
                      color="info"
                      onClick={() =>
                        arrayHelpers.push({
                          question: "",
                          type: "",
                        })
                      }
                    >
                      <Stack direction="row" alignItems="center" justifyContent="center">
                        <AddIcon sx={{ fontSize: "16px" }} />
                        <MDTypography color="info" sx={{ fontSize: "16px" }}>
                          Add Question
                        </MDTypography>
                      </Stack>
                    </MDButton>
                  </MDBox>
                </MDBox>
              )}
            />
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Questions;
